import React from "react";
import { useTable } from "react-table";

const Table = ({ columns, data }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  if (data.length === 0) {
    return <></>;
  }

  const totalArray = [];
  data.forEach((reward) => totalArray.push(reward.usdtotal));
  const total = totalArray.reduce((r, c) => r + parseFloat(c), 0);

  return (
    <div className="container-fluid">
      <table className="table table-striped" {...getTableProps()}>
        <caption className="caption-top text-end fs-2 fw-bold">
          Income Total: ${total.toFixed(2)}
        </caption>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
